import React, {useContext, useEffect, useState} from 'react'
import {Form, Row} from 'react-bootstrap'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import {getProcessSheetTags} from '../../../../services/procesos'
import {PartnerContext} from '../PartnerContexts'
import {Field, ListTags, ProcessSheet, Section, Sheet, Tag} from '../documentInterface'
import TagsListGroup from './TagsListGroup'

const TagsEditModalForm: React.FC = () => {
  const {process_id, processSheetData, setProcessSheetData} = useContext(PartnerContext)

  const [listTags, setListTags] = useState<ListTags[]>([])

  useEffect(() => {
    if (process_id) {
      getProcessSheet(process_id)
    }
  }, [])

  useEffect(() => {
    showTask()
  }, [processSheetData])

  const getProcessSheet = (id: string) => {
    getProcessSheetTags(id)
      .then((response) => {
        setProcessSheetData(response.data)
      })
      .catch((error) => console.log(error))
  }

  const showTask = () => {
    const listTagsAux: ListTags[] = []
    // if process is regular, get from central entity
    processSheetData.forEach((process_sheet: ProcessSheet) => {
      process_sheet.fichas.forEach((sheet: Sheet) => {
        sheet.seccion.forEach((section: Section) => {
          const tags: Tag[] = []
          section.campos.forEach((field: Field) => {
            tags.push({
              identifier: field._id,
              tags: field.tag ? field.tag : '',
              label: field.titulo,
              type: 'string',
            })
          })
          listTagsAux.push({label: section.nombre, fields: tags})
        })
      })
    })
    setListTags(listTagsAux)
  }

  return (
    <>
      <Form>
        <Row className='mb-3'>
          <TagsListGroup List={listTags} />
        </Row>
      </Form>
    </>
  )
}

export {TagsEditModalForm}
